<template lang="pug">
  #body
    #view(v-html="html")
</template>

<script>
import Api from '@/services/apiService'

export default {
  name: 'App',

  props: {
    id: Number
  },
  data () {
    return {
      html: Object
    }
  },
  mounted () {
    Api.getStaticbyRoute(this.$route.fullPath.substr('/cms-public/'.length)).then(res => {
      this.html = res.data.htmlCode
    })
  }

}
</script>

<style scoped>
    #body {
        overflow: auto;
        display: inline-block;
        width: 100%
    }
    #view {
        padding: 10px;
    }
</style>
